<template>
  <div class="add-box common-shadow">
    <vxe-table
        border="none"
        show-overflow
        class="table-style"
        :auto-resize="true"
        align="center"
        :data="tableData"
    >
      <vxe-table-column field="chainNum" title="主订单编号">
        <template v-slot="{ row }">
          <a @click="openOrderDetail(row.chainId, 0)" style="color: #2d8cf0">{{
            row.chainNum
            }}</a>
        </template>
      </vxe-table-column>
      <vxe-table-column field="contractNum" title="关联合同">
        <template v-slot="{ row }">
          <a @click="showDetail(orderInfo.contractId)" style="color: #2d8cf0">{{
            row.contractNum
            }}</a>
        </template>
      </vxe-table-column>
      <vxe-table-column
          field="contractBusType"
          title="业务类别"
      ></vxe-table-column>
      <!-- <vxe-table-column field="contractTitle" title="订单标题"></vxe-table-column> -->
      <!-- <vxe-table-column field="addTime" title="签约日期" width="10%"></vxe-table-column> -->
      <vxe-table-column field="buyerName" title="托运人名称"></vxe-table-column>
      <vxe-table-column
          field="sellerName"
          title="承运人名称"
      ></vxe-table-column>
      <!-- <vxe-table-column field="amountTotal" title="总金额"></vxe-table-column> -->
    </vxe-table>
    <vxe-table
        border="none"
        show-overflow
        class="table-style"
        max-height="350"
        :auto-resize="true"
        align="center"
        :data="goodsArr"
    >
      <vxe-table-column field="orderPicUrl" title="附件" min-width="80">
        <template v-slot="{ row }">
          <upload-detail :arrList="row.orderPicUrl"></upload-detail>
        </template>
      </vxe-table-column>
      <vxe-table-column field="addTime" title="签约日期" min-width="120">
        <template v-slot="{ row }">
          <span>{{ row.addTime | timeFormatDate }}</span>
        </template>
      </vxe-table-column>
      <vxe-table-column
          field="goodsType"
          title="货物类型"
          min-width="120"
      ></vxe-table-column>
      <vxe-table-column
          field="goodsName"
          title="货名"
          min-width="120"
      ></vxe-table-column>
      <vxe-table-column
          field="rule"
          title="规格"
          min-width="70"
      ></vxe-table-column>
      <!-- <vxe-table-column
          field="packUnit"
          title="包装形式"
          min-width="80"
      ></vxe-table-column> -->
      <vxe-table-column
          field="unit"
          title="单位"
          min-width="70"
      ></vxe-table-column>
      <vxe-table-column
          field="counts"
          title="数量"
          min-width="90"
      ></vxe-table-column>
      <vxe-table-column
          field="price"
          title="单价"
          min-width="110"
      ></vxe-table-column>
      <vxe-table-column
          field="amount"
          title="总金额"
          min-width="110"
      ></vxe-table-column>
      <vxe-table-column field="priceType" title="计费方式" min-width="80">
        <template v-slot="{ row }">
          <span>{{ row.priceType | priceTypeMap }}</span>
        </template>
      </vxe-table-column>
      <vxe-table-column field="isTax" title="含税" min-width="60">
        <template v-slot="{ row }">
          <span>{{ row.isTax | taxMap }}</span>
        </template>
      </vxe-table-column>
      <vxe-table-column
          field="carShipNum"
          title="车船号"
          min-width="120"
      ></vxe-table-column>
      <!-- <vxe-table-column field="deliveryPoints" title="交货地点" width="8%"></vxe-table-column> -->
      <vxe-table-column
          field="beginPlace"
          title="起运地"
          min-width="120"
      >
        <template v-slot="{ row }">
          <span>{{ row.beginPlace ? row.beginPlace.replace(/,/g, '') : '' }}</span>
        </template>
      </vxe-table-column>
      <vxe-table-column field="beginTime" title="受载/起运时间" min-width="160">
        <template v-slot="{ row }">
          <span v-if="tableData[0].contractBusType === '陆运'">{{ row.beginTime | timeFormat }}</span>
          <span v-else>{{ row.beginTime | timeFormatDate }}</span>
        </template>
      </vxe-table-column>
      <vxe-table-column
          field="endPlace"
          title="到达地"
          min-width="120"
      >
        <template v-slot="{ row }">
          <span>{{ row.endPlace ? row.endPlace.replace(/,/g, '') : ''}}</span>
        </template>
      </vxe-table-column>
      <vxe-table-column field="endTime" title="到达时间" min-width="160">
        <template v-slot="{ row }">
          <span v-if="tableData[0].contractBusType === '陆运'">{{ row.endTime | timeFormat }}</span>
          <span v-else>{{ row.endTime | timeFormatDate }}</span>
        </template>
      </vxe-table-column>
      <vxe-table-column
          field="driverName"
          title="司机"
          min-width="80"
          v-if="tableData[0].contractBusType === '陆运'"
      ></vxe-table-column>
      <vxe-table-column
          field="driverPhone"
          title="手机号"
          min-width="120"
          v-if="tableData[0].contractBusType === '陆运'"
      ></vxe-table-column>
    </vxe-table>
    <vxe-pager
        background
        v-show="totalGoods > 10"
        size="small"
        :current-page.sync="page.currentPage"
        :page-size.sync="page.pageSize"
        :total="totalGoods"
        @page-change="handlePageChange"
    ></vxe-pager>
    <vxe-table
        border="none"
        show-overflow
        class="table-style"
        :auto-resize="true"
        align="center"
        :data="AmountTableData"
    >
      <vxe-table-column
          field="associateCounts"
          title="实际数量"
      ></vxe-table-column>
      <vxe-table-column field="receivablesAmount" title="应收总额"></vxe-table-column>
      <vxe-table-column field="receivedAmount" title="已收总额"></vxe-table-column>
      <vxe-table-column field="uncollectedAmount" title="未收总额"></vxe-table-column>
      <vxe-table-column
          field="invoiceCount"
          title="关联发票数"
      ></vxe-table-column>
      <vxe-table-column
          field="invoiceAmount"
          title="发票总额"
      ></vxe-table-column>
    </vxe-table>
    <!-- <div class="detail-upload">
      <h3>查看附件</h3>
      <div class="detail-upload-con">
        <div class="upload-list" v-for="(item,index) in imageData" :key="index">
          <span
              class="pdf-box ellipsis"
              v-if="/(.pdf)$/i.test(item.url)"
              @click="clickFile(item.url)"
          ></span>
          <span v-else>
            <img :src="item.url" @click="getBigPic(index)"/>
          </span>
          <div
              class="upload-hover-title"
              @click="clickFile(item.url)"
              v-if="/(.pdf)$/i.test(item.url)"
          >{{item.oldName}}
          </div>
          <div class="upload-hover-title" @click="getBigPic(index)" v-else>{{item.oldName}}</div>
        </div>
      </div>
    </div> -->

    <div class="show-pic" v-show="isShowPicBox">
      <picture-viewer
          v-if="lookImageData && lookImageData.length > 0"
          :imgData="lookImageData"
          :picIndex="showPicIndex"
      ></picture-viewer>
    </div>
    <vxe-modal
        v-model="visible"
        :title="modalTitle"
        width="1300"
        height="650"
        @close="closeCreate"
        resize
        remember
    >
      <create-buyer-modal ref="modalCreate" @close="close"></create-buyer-modal>
    </vxe-modal>
    <vxe-modal
        v-model="viewBuyer"
        title="查看托运人合同"
        width="1300"
        height="650"
        @close="closeDetail"
        resize
        remember
    >
      <view-detail-modal
          ref="modalDetail"
          @goEdit="goEdit"
          :editVisible="isHavePermission('buyer:updateContract')"
      ></view-detail-modal>
    </vxe-modal>
  </div>
</template>

<script>
  import $api from "@/apiProvider";
  import {contractbusMap, numberToCurrency, formatMoney} from "@/filters/type";
  import {timeFormatDate} from "@/filters/time";
  import PictureViewer from "@/components/common/PictureViewer";
  import ViewDetailModal from "@/views/agreement/ViewDetailModal";
  import CreateBuyerModal from "@/views/agreement/CreateBuyerModal";
  import viewOrderDetail from "@/mixin/viewOrderDetail";
  import getAuthOrization from "@/mixin/getAuthOrization";
  import UploadDetail from "@/components/common/UploadDetail";

  export default {
    mixins: [getAuthOrization, viewOrderDetail],
    components: {
      PictureViewer,
      ViewDetailModal,
      CreateBuyerModal,
      UploadDetail,
    },
    props: {
      orderInfo: Object,
      imageData: Array,
    },
    data() {
      return {
        isShowPicBox: false,
        showPicIndex: 0,
        viewBuyer: false,
        contractId: null,
        visible: false,
        modalTitle: "",
        page: {
          currentPage: 1,
          pageSize: 10,
          totalResult: 0,
        },
        goodsArr: null,
        // totalGoods: null,
      };
    },
    created() {
      this.$bus.$on("isShowBigPic", (data) => {
        this.isShowPicBox = data;
      });
    },

    computed: {
      orderId() {
        if (this.orderInfo) {
          return this.orderInfo.id;
        } else {
          return null;
        }
      },
      totalGoods() {
        if (this.orderInfo && this.orderInfo.goodsPageInfo) {
          return this.orderInfo.goodsPageInfo.total;
        } else {
          return 0;
        }
      },
      // goodsArr() {
      //   let arr = [];
      //   if (this.isChangeByPage) {
      //     arr = this.eidtGoodsArr;
      //   } else {
      //     if (
      //       this.orderInfo.goodsRtnVos &&
      //       this.orderInfo.goodsRtnVos.length > 0
      //     ) {
      //       arr = this.orderInfo.goodsRtnVos;
      //     } else {
      //       arr = [];
      //     }
      //   }

      //   return arr;
      // },
      tableData() {
        let arr = [];
        let obj = {
          chainId: this.orderInfo.chainId,
          chainNum: this.orderInfo.chainNum,
          contractNum: this.orderInfo.contractNum,
          contractBusType: contractbusMap(this.orderInfo.contractBusType),
          contractTitle: this.orderInfo.contractTitle,
          addTime: timeFormatDate(this.orderInfo.addTime),
          buyerName: this.orderInfo.buyerName,
          sellerName: this.orderInfo.sellerName,
          amountTotal: numberToCurrency(this.orderInfo.amountTotal),
          orderPicUrl: null,
        };
        arr.push(obj);
        return arr;
      },

      AmountTableData() {
        let uncollectedAmount = this.orderInfo.uncollectedAmount
          ? this.orderInfo.uncollectedAmount
          : 0;
        let arr = [];
        let obj = {
          associateCounts: this.orderInfo.associateCounts,
          invoiceCount: this.orderInfo.invoiceCount,
          invoiceAmount: numberToCurrency(this.orderInfo.invoiceAmount),
          receivablesAmount: formatMoney(this.orderInfo.receivablesAmount),
          receivedAmount: formatMoney(this.orderInfo.receivedAmount),
          uncollectedAmount: formatMoney(uncollectedAmount),
        };
        arr.push(obj);
        return arr;
      },
      lookImageData() {
        let arr = [];
        if (this.imageData && this.imageData.length > 0) {
          arr = this.imageData.filter((v) => {
            let regPdf = /(.pdf)$/i;
            return !regPdf.test(v.name);
          });
        }
        // console.log(arr, "arrr");
        return arr;
      },
    },
    watch: {
      orderId: {
        deep: true,
        immediate: true,
        handler: function (val, oldVal) {
          if (val) {
            this.getInitData();
          }
        },
      },
    },
    methods: {
      clickFile(url) {
        window.open(url);
      },
      getInitData() {
        this.goodsArr = this.orderInfo.goodsRtnVos;
        this.page.currentPage = 1;
        this.page.pageSize = 10;
      },
      handlePageChange() {
        $api.order.queryOrdersBuyerDetailModel
          .POST({
            data: {
              id: parseInt(this.orderId),
              page: this.page.currentPage,
              rows: this.page.pageSize,
            },
          })
          .then((res) => {
            if (res.status === 1) {
              this.goodsArr = res.data.goodsRtnVos;
            }
          });
      },
      getBigPic(i) {
        this.showPicIndex = i;
        this.$bus.$emit("isShowBigPic", true);
      },
      showDetail(id) {
        if (!this.isHavePermission('buyer:queryContractDetail')){
          this.$Message["info"]({
            background: true,
            content: "对不起，您没有该权限！"
          });
          return ;
        }
        this.contractId = id;
        this.viewBuyer = true;
        this.$refs.modalDetail.queryContractDetail(id);
      },
      closeDetail() {
        this.$refs.modalDetail.close();
      },
      goEdit() {
        this.modalTitle = "编辑托运人合同";
        this.visible = true;
        this.$refs.modalCreate.queryContractDetail(this.contractId);
      },
      closeCreate() {
        this.$refs.modalCreate.close();
      },
      close(value) {
        if (value === "add") {
          this.visible = false;
        } else if (value === "update") {
          this.visible = false;
          this.viewBuyer = false;
          this.$refs.modalDetail.close();
        }
        this.$emit("update");
      },
    },
  };
</script>

<style>
</style>